export const useGetParsedItemFromLocalStorage = <T>(name: string): T | null => {
  const item = window.localStorage.getItem(name)
  if (!item) return null
  return JSON.parse(item)
}
